import { PencilIcon, CheckboxIcon, TrashIcon } from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import classnames from "classnames";
import React from "react";
import { Tooltip, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { FlexboxGrid } from "@components/Common/FlexboxGrid";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import {
    store as device,
    setActions,
    setIsActionsClicked,
    setIsEdited,
} from "./store";
import { formatCityAmountLivraisonData } from "./hooks";
import { PostCity } from "../City/hooks";
import ErrorToast from "@components/Common/ErrorTost";
import { setOrders, store as shopStore } from "../../store";
import { useFetchGlobal } from "../../../../../../api/hooks";
import { store as storeGlobal } from "@components/VerticalLayout/store";

export default function CustomIcons({
    e,
    setSelectedRows,
    setIsAddCityAmount,
    isAddCityAmount,
    selectedRowShops,
    setDataIsUpdated,
    cityData,
}: any) {
    const { t } = useTranslation();
    const { isActionsClicked, isEdited } = useSnapshot(device);
    const { fetchGlobal } = useFetchGlobal();

    const { franchiseID } = useSnapshot(storeGlobal);

    const [isAlertModalOpened, setIsAlertModalOpened] = React.useState<boolean>(
        false
    );

    function alertToggle() {
        setIsAlertModalOpened(!isAlertModalOpened);
    }

    async function deleteVille() {
        const localStCityLivraison = formatCityAmountLivraisonData(
            cityData.data
        );
        const arryCities = localStCityLivraison.filter((element: any) => {
            const sameCode =
                (e.selectedRow[t("Postal code")] ||
                    e.selectedRow["Code Postal"]) === element["CodePostale"];
            const sameCity =
                (e.selectedRow[t("City")] || e.selectedRow["Ville"]) ===
                element["NomVille"];
            return !(sameCode && sameCity);
        });
        let data = {
            shopId: selectedRowShops[0].shopId,
            franchiseID: franchiseID,
            key: "STVilleLivraisonMontant",
            data: arryCities,
        };
        try {
            const responseData: any = await PostCity(data, fetchGlobal);
            if (responseData.error) {
                throw new Error("API returned an error");
            }

            const updatedDataPrice = {
                ...(shopStore.orders.dataPrice || {}),
                STVilleLivraisonMontant: data.data,
            };
            setOrders({ dataPrice: updatedDataPrice });
            toast.success(`${t("Deletion completed successfully")!}`, {
                position: toast.POSITION.TOP_CENTER,
                theme: "colored",
                icon: <CheckboxIcon height={25} width={25} fill="white" />,
            });
            setIsAlertModalOpened(false);
            setDataIsUpdated(true);
        } catch (e) {
            ErrorToast(`${t("There's an error")!}`);
        }
    }

    return (
        <div
            data-testid="city-amount-actions"
            className="d-flex justify-content-between mt-2"
        >
            <Tooltip title={t("Edit")}>
                <IconButton data-testid="city-amount-edit-btn">
                    <PencilIcon
                        onClick={() => {
                            if (isEdited === true) {
                                setIsActionsClicked(!isActionsClicked);
                                setActions(() => {
                                    setIsEdited(false);
                                    setSelectedRows([e.selectedRow]);
                                    setIsAddCityAmount(true);
                                });
                            } else {
                                setSelectedRows([e.selectedRow]);
                                setIsAddCityAmount(true);
                            }
                        }}
                        height={25}
                        width={25}
                        style={{ cursor: "pointer" }}
                        className={`${classnames("pointer__clz")}`}
                    />
                </IconButton>
            </Tooltip>

            <Tooltip title={t("Delete")}>
                <IconButton data-testid="city-amount-delete-btn">
                    <TrashIcon
                        onClick={() => {
                            if (isEdited === true) {
                                setIsActionsClicked(!isActionsClicked);
                                setActions(() => {
                                    setIsEdited(false);
                                    setSelectedRows([e.selectedRow]);
                                    setIsAlertModalOpened(!isAlertModalOpened);
                                });
                            } else {
                                setSelectedRows([e.selectedRow]);
                                setIsAlertModalOpened(!isAlertModalOpened);
                            }
                        }}
                        height={25}
                        width={25}
                        fill="red"
                        style={{ cursor: "pointer" }}
                        className={`${classnames("pointer__clz")}`}
                    />
                </IconButton>
            </Tooltip>
            <div />
            <Modal
                isOpen={isAlertModalOpened}
                toggle={alertToggle}
                backdrop={false}
                fade={false}
                centered
            >
                <ModalHeader toggle={alertToggle}>
                    <span
                        style={{
                            textAlign: "left",
                            font: " normal normal 600 25px Segoe UI",
                            color: "#000000",
                        }}
                    >
                        {t("Alert")}
                    </span>
                </ModalHeader>
                <ModalBody
                    className="d-flex flex-column"
                    style={{ gap: "10px" }}
                >
                    <div
                        style={{
                            font: " normal normal 600 16px/20px Segoe UI",
                            textAlign: "left",
                            color: "#2B2828",
                            padding: "14px",
                        }}
                    >
                        {t(
                            "Do you want to confirm the deletion of the selected city?"
                        )}
                    </div>
                    <FlexboxGrid
                        className="pt-4 justify-content-end"
                        gap="10px"
                    ></FlexboxGrid>
                </ModalBody>
                <ModalFooter className="border-top-0">
                    <CustomSecondaryColorButton
                        outline
                        variant="light"
                        onClick={() => {
                            setIsAlertModalOpened(!isAlertModalOpened);
                            setDataIsUpdated(true);
                        }}
                        rounded
                    >
                        {t("Cancel")}
                    </CustomSecondaryColorButton>
                    <CustomMainColorButton
                        rounded
                        className="mr-2"
                        variant="primary"
                        onClick={() => {
                            deleteVille();
                        }}
                    >
                        {t("Validate")}
                    </CustomMainColorButton>
                </ModalFooter>
            </Modal>
        </div>
    );
}
